var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container is-fluid" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-alpine",
                staticStyle: { width: "100%", height: "700px" },
                attrs: {
                  id: _vm.gridId,
                  "grid-options": _vm.gridOptions,
                  "get-child-count": _vm.getChildCount,
                  pagination: true,
                  "pagination-auto-page-size": true,
                  "animate-rows": true,
                  "side-bar": ["columns"],
                  "multi-sort-key": "ctrl",
                  modules: _vm.modules,
                  "get-context-menu-items": _vm.getContextMenuItems,
                },
                on: { "grid-ready": _vm.gridReady },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.selectedShipmentModal.isActive,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.selectedShipmentModal, "isActive", $event)
            },
            close: function ($event) {
              _vm.selectedShipmentModal.materials = []
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-card",
              staticStyle: { "min-height": "630px" },
            },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(" Materials "),
                ]),
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c(
                    "b-field",
                    { attrs: { grouped: "" } },
                    [
                      _c(
                        "b-field",
                        [
                          _c("b-input", {
                            attrs: {
                              placeholder: "Search...",
                              type: "search",
                              icon: "search",
                            },
                            model: {
                              value: _vm.searchMaterial,
                              callback: function ($$v) {
                                _vm.searchMaterial = $$v
                              },
                              expression: "searchMaterial",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "is-info",
                                "icon-left": "file-csv",
                              },
                              on: {
                                click: _vm.downloadSelectShipmentMaterials,
                              },
                            },
                            [_vm._v(" Export ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-table",
                    {
                      attrs: {
                        "per-page": 15,
                        data: _vm.filteredMaterials,
                        loading: _vm.selectedShipmentModal.isLoading,
                        narrowed: "",
                        striped: "",
                        paginated: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function (props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.column.label))]),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "b-table-column",
                                {
                                  attrs: {
                                    field: "barcode",
                                    label: "Barcode",
                                    sortable: "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(props.row.barcode) + " ")]
                              ),
                              _c(
                                "b-table-column",
                                {
                                  attrs: {
                                    field: "material",
                                    label: "Material",
                                    sortable: "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(props.row.material) + " ")]
                              ),
                              _c(
                                "b-table-column",
                                {
                                  attrs: {
                                    field: "scannedAt",
                                    label: "Scanned at",
                                    sortable: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        new Date(
                                          props.row.scannedAt
                                        ).toLocaleString()
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "bottom-left" }, [
                        _c("b", [_vm._v("Total")]),
                        _vm._v(
                          ": " + _vm._s(_vm.filteredMaterials.length) + " "
                        ),
                      ]),
                      _c(
                        "template",
                        { slot: "empty" },
                        [_c("nothing-here")],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c("footer", { staticClass: "modal-card-foot" }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }